import React, { useContext, useEffect, useRef, useState } from 'react'
import { useNavigate } from 'react-router-dom'

import { DueOut } from '../../../assets/ts/data/dueout/dueout'
import { DueOutProcessFlowMetadata } from '../../../assets/ts/data/dueout/dueout-process-flow-metadata'
import { Inquiry } from '../../../assets/ts/data/inquiry/inquiry'
import { InquiryProcessFlowMetadata } from '../../../assets/ts/data/inquiry/inquiry-process-flow-metadata'
import { convertToPlainText } from '../../../assets/ts/formatting/formatting'
import { convertSiteAdmin } from '../../../assets/ts/general/general'
import Alert from '../../../components/alert/alert'
import AssignToButton from '../../../components/buttons/assign-to-button'
import BasicActionButton from '../../../components/buttons/basic-action-button'
import Buttons from '../../../components/buttons/buttons'
import DueoutBasicActionButton from '../../../components/buttons/dueout-basic-action-button'
import ElevateButton from '../../../components/buttons/elevate-button'
import useInquiryHistory from '../../../hooks/use-inquiry-history'
import { MetadataContext } from '../../../store/metadata-context-provider'
import { RoleContext } from '../../../store/role-context-provider'
import { SelectionContext } from '../../../store/selection-context-provider'
import { UserContext } from '../../../store/user-context-provider'
import {
  ACTION_BUTTON_POPUP_CONTROL,
  ACTIONS,
  DUEOUT_ACTION_STRING,
  INQUIRY_ACTION_STRINGS,
  INQUIRY_STATUS_IDS,
  MPF_ACTIVE_INQUIRY_KPI,
  USER_ROLES,
} from '../../../utils/constants/global-constants'

interface Props {
  actionType: 'Dueout' | 'Inquiry'
  currentUserRoleProps: any
  data?: DueOut | Inquiry // Only used on Detail View page
  fetchSelectedItems?: any //Only used on List pages
  isMenusExpanded?: boolean
  pageType?: string
  refresh: boolean
  setDisableCheckBox?: any
  setRefresh: any
  showAssignTo?: boolean
  showElevate?: boolean
}
interface GENERATED_ROLE {
  processFlowsRelativeToInquiries?: DueOutProcessFlowMetadata[] | InquiryProcessFlowMetadata[]
  role: string
}

interface ActionButton {
  AssignTo: boolean
  CancelDueout: boolean
  CancelInquiry: boolean
  CancelResponseRequired: boolean
  Close: boolean
  CloseDueout: boolean
  Complete: boolean
  CustomerAction: boolean
  CustomerActionComplete: boolean
  Elevate: boolean
  OutsideActionComplete: boolean
  PendingActionOutside: boolean
  Reopen: boolean
  Resolve: boolean
  Respond: boolean
}
const ActionButtonsContainer = ({
  actionType,
  currentUserRoleProps,
  data,
  fetchSelectedItems,
  isMenusExpanded,
  pageType,
  refresh,
  setDisableCheckBox,
  setRefresh,
  showAssignTo,
  showElevate,
}: Props) => {
  const initialBtnShowHide = {
    AssignTo: false,
    CancelDueout: false,
    CancelInquiry: false,
    CancelResponseRequired: false,
    Close: false,
    CloseDueout: false,
    Complete: false,
    CustomerAction: false,
    CustomerActionComplete: false,
    Elevate: false,
    OutsideActionComplete: false,
    PendingActionOutside: false,
    Reopen: false,
    Resolve: false,
    Respond: false,
  }
  const { currentUserRole, setCurrentUserRole } = currentUserRoleProps

  const {
    initialInquiryAndDueoutFilter,
    isCPOwner,
    isCSS,
    isCustomer,
    isLeadership,
    isMPFOwner,
    isSiteAdmin,
    mpfSection,
    userProcessFlows,
    userType,
  } = useContext(RoleContext)
  const { HistoryData } = useInquiryHistory({ InquiryGUID: data?.InquiryGUID })
  const { me } = useContext(UserContext)
  const { inquiryStatuses } = useContext(MetadataContext)
  const selection = useContext(SelectionContext)

  const navigate = useNavigate()
  const popupBtnRef = useRef<HTMLInputElement>(null)

  const [offsetLeftValue, setOffsetLeftValue] = useState<number>(0)
  const [offsetTopValue, setOffsetTopValue] = useState<number>(0)
  const [offsetWidthValue, setOffsetWidthValue] = useState<number>(0)
  const [popupHeight, setPopupHeight] = useState<number>(0)
  const [popupTop, setPopupTop] = useState<number>(0)
  const [xPositionValue, setXPositionValue] = useState<number>(0)
  const [xPositionValueUpdate, setXPositionValueUpdate] = useState<number>(0)

  const [displayAlert, setDisplayAlert] = useState<boolean>(false)

  const [alertMessage, setAlertMessage] = useState<string>('')
  const [openedButton, setOpenedButton] = useState<string>('')
  const [statusRelativeToUser, setStatusRelativeToUser] = useState<string>('')

  const [assignToOptions, setAssignToOptions] = useState([])
  const [elevateToOptions, setElevateToOptions] = useState([])
  const [respondToUser, setRespondToUser] = useState([])
  const [selectedItems, setSelectedItems] = useState([])

  const [elevateInputs, setElevateInputs] = useState({
    ElevateTo: '',
    Priority: data?.Priority,
    comment: '',
  })
  const [showElevateErrorMsgs, setShowElevateErrorMsgs] = useState({
    ElevateTo: { show: false },
    comment: { show: false },
  })

  const [actionBtnShowHide, setActionBtnShowHide] = useState({
    AssignTo: false,
    CancelDueout: false,
    CancelInquiry: false,
    CancelResponseRequired: false,
    Close: false,
    CloseDueout: false,
    Complete: false,
    CustomerAction: false,
    CustomerActionComplete: false,
    Elevate: false,
    OutsideActionComplete: false,
    PendingActionOutside: false,
    Reopen: false,
    Resolve: false,
    Respond: false,
  })
  const [btnShowHide, setBtnShowHide] = useState(initialBtnShowHide)

  const redirectToBack = () => {
    navigate(-1)
  }
  const noItemsSelectedValidation = (multipleItems) => {
    if (multipleItems.length === 0) {
      return true
    }
    return false
  }
  const selectedItemDoesntMatchRoleValidation = (multipleItems) => {
    if (userType.includes('SiteAdmin')) {
      const firstValue = multipleItems[0]['CurrentlyServicingBy']
      const allSame = multipleItems.every((obj) => obj['CurrentlyServicingBy'] === firstValue)
      return !allSame
    } else {
      return multipleItems.some((item) => {
        if (item.CurrentlyServicingBy === 'CSS' && !userType.includes('CSS')) {
          return true
        } else if (item.CurrentlyServicingBy === 'MPF' && userType.includes('CSS')) {
          return true
        } else {
          return false
        }
      })
    }
  }

  const selectedItemHaveMultipleServicingUnits = (multipleItems) => {
    if (userType.includes('SiteAdmin')) {
      const firstValue = multipleItems[0]['CurrentlyServicingBy']
      const allSame = multipleItems.every((obj) => obj['CurrentlyServicingBy'] === firstValue)
      return !allSame
    } else {
      return multipleItems.every((item) => {
        if (item.CurrentlyServicingBy === 'CSS' && !userType.includes('CSS')) {
          return true
        } else if (item.CurrentlyServicingBy === 'MPF' && userType.includes('CSS')) {
          return true
        } else {
          return false
        }
      })
    }
  }
  /** FUNCTION_NAME: popupCloseOpenFunctionality
   *
   * @returns - Description This function controls when an action button is clicked. It opens an
   * an action button and close any other button that was opened.
   */
  function popupCloseOpenFunctionality(
    type: string,
    value: any,
    top: number,
    xPosition: number,
    left: number,
    elementHeight: number,
    offsetWidth: number
  ) {
    // Set popup position values
    setPopupTop(top)
    setXPositionValue(xPosition)
    setOffsetTopValue(top)
    setOffsetLeftValue(left)
    setOffsetWidthValue(offsetWidth)
    setOpenedButton(type)

    // Clone the current button states
    const updatedButtons = { ...actionBtnShowHide }
    //This block sets the button correctly
    if (value == true) {
      updatedButtons[type] = value
    }
    // Ensure that only the clicked button is active and others are deactivated
    for (const button in updatedButtons) {
      if (button === type) {
        if (pageType === 'inquiries' && noItemsSelectedValidation(selectedItems)) {
          updatedButtons[button] = false
          setAlertMessage('Please select an inquiry.')
          setDisplayAlert(true)
        } else if (
          pageType === 'inquiries' &&
          selectedItemHaveMultipleServicingUnits(selectedItems)
        ) {
          updatedButtons[button] = false
          setAlertMessage(
            "You don't have permission to perform this action on the selected item(s)"
          )
          setDisplayAlert(true)
        } else if (
          pageType === 'inquiries' &&
          selectedItemDoesntMatchRoleValidation(selectedItems)
        ) {
          updatedButtons[button] = false
          setAlertMessage(
            'Please select inquiries with the same Section and Current Servicing Unit'
          )
          setDisplayAlert(true)
        } else {
          setDisableCheckBox ? setDisableCheckBox(true) : ''
        }
      } else {
        // Deactivate other buttons when one is clicked
        updatedButtons[button] = false
      }
    }

    // Set the state for the selected action and button visibility
    setActionBtnShowHide(updatedButtons)

    // Reset fields if necessary (for example, when 'Elevate' is toggled)
    if (type === 'Elevate') {
      setElevateInputs({
        ElevateTo: '',
        Priority: data?.Priority,
        comment: '',
      })
      setShowElevateErrorMsgs({
        ElevateTo: { show: false },
        comment: { show: false },
      })
    }
  }

  /** FUNCTION_NAME:generateCurrentRole
   *
   * @returns - Description This function create a user role from the status of an iquiry and the user role oermission.
   * Then returens processFlowsRelativeToInquiries and the user role relative to the inquiry.
   */
  const generateCurrentRole = (data, action = '', newInquiryData?: Inquiry): GENERATED_ROLE => {
    // the current role the user is using will depend on the following fields from the currently selected items(s)
    const currentSection = data['Section/MetadataValue'] || data.SectionValue
    const currentStatusID = data.StatusCode
    const currentStatus = data['Status/StatusDescription'] || data.Status
    const previousSection = data['PreviousSection/MetadataValue'] || data.PreviousSectionValue
    const servicingByOrCurrentlyServicingBy = data.InquiryID
      ? 'CurrentlyServicingBy'
      : 'ServicingBy'

    // if the user is a customer ONLY then assign 'Customer' as the user role
    if (isCustomer || data.Customer.userID === me.userId) {
      const processFlowsRelativeToInquiries = userProcessFlows.filter((pf) => {
        return (
          (pf.StatusCode.replace(
            '[SECTION_NAME]',
            currentSection.split(' ').join('_')
          ).toLowerCase() == currentStatusID.toLowerCase() &&
            pf.UserType == 'Customer') ||
          (pf.StatusCode.replace('[SECTION_NAME]', currentSection).toLowerCase() ==
            currentStatus.toLowerCase() &&
            pf.UserType == 'Customer')
        )
      })
      const role = processFlowsRelativeToInquiries[0]?.Role.replace(
        '[SECTION_NAME]',
        currentSection
      )
      return {
        processFlowsRelativeToInquiries,
        role,
      }
    } else if (
      isCPOwner ||
      isMPFOwner ||
      (isLeadership && (data['CurrentlyServicingBy'] === 'MPF' || data['ServicingBy'] === 'MPF')) ||
      (isCSS &&
        data.InquiryID &&
        initialInquiryAndDueoutFilter.cssPASCODES.includes(data['PASCODE']) && // CSS on Inquiry
        data['CurrentlyServicingBy'] === 'CSS') ||
      (isCSS &&
        data.DueOutID &&
        initialInquiryAndDueoutFilter.cssPASCODES.includes(data['PASCODE']) && // CSS on DueOut
        data['ServicingBy'] === 'CSS')
    ) {
      const processFlowsRelativeToInquiries = userProcessFlows.filter((pf) => {
        return (
          (pf.StatusCode.replace('[SECTION_NAME]', currentSection).toLowerCase() ==
            currentStatus?.split('_').join(' ').toLowerCase() ||
            pf.StatusCode.replace('[SECTION_NAME]', currentSection).toLowerCase() ==
              currentStatusID.toLowerCase()) &&
          pf.UserType !== 'Customer'
        )
      })
      let role =
        isCPOwner || isMPFOwner
          ? convertSiteAdmin(data, HistoryData[0])
          : processFlowsRelativeToInquiries[0]?.Role.replace('[SECTION_NAME]', currentSection)
      //CP and MPF Owner role when processing due out defaults to Technician.
      if (data.DueOutGUID && !isLeadership) {
        role = data['ServicingBy'] === 'MPF' ? 'Technician' : 'CSS'
      }

      return {
        processFlowsRelativeToInquiries,
        role,
      }
    } else {
      // search the process flows to get ONLY the relevant flows for the current inquiry Section, Status, and action
      let statusIdToCheck = currentStatusID
      const processFlowsRelativeToInquiries = userProcessFlows.filter((pf) => {
        const sections = mpfSection.some((sec) => {
          if (
            sec == data?.['Section/MetadataValue'] ||
            sec?.toUpperCase() == data?.SectionValue?.toUpperCase()
          ) {
            return (
              ((pf.StatusCode.replace('[SECTION_NAME]', sec).toLowerCase() ==
                currentStatus?.toLowerCase() &&
                data[servicingByOrCurrentlyServicingBy] === 'MPF') ||
                (pf.StatusCode.replace('[SECTION_NAME]', sec).toLowerCase() ==
                  currentStatusID?.toLowerCase() &&
                  data[servicingByOrCurrentlyServicingBy] === 'MPF')) &&
              userType.includes(pf.UserType)
            )
          }
        })
        return sections
      })
      let previousSectionRole

      if (
        data.ResponseRequired &&
        mpfSection.includes(
          data['PreviousSection/MetadataValue'] || mpfSection.includes(data['PreviousSectionValue'])
        )
      ) {
        // if (action == ACTIONS.CancelResponseRequired) {
        statusIdToCheck = data.PreviousStatusCode
        action = ''
        const previousProcessFlowsRelativeToInquiries = userProcessFlows.filter((pf) => {
          const sections = mpfSection.some((sec) => {
            return (
              convertToPlainText(pf.StatusCode.replace('[SECTION_NAME]', sec)).toLowerCase() ==
                convertToPlainText(statusIdToCheck)?.toLowerCase() &&
              data[servicingByOrCurrentlyServicingBy] === 'MPF' &&
              userType.includes(pf.UserType)
            )
          })
          return sections
        })
        previousSectionRole = previousProcessFlowsRelativeToInquiries[0]?.Role.replace(
          '[SECTION_NAME]',
          previousSection
        )
        // }
      }

      if (action == INQUIRY_ACTION_STRINGS.AssignTo && newInquiryData) {
        statusIdToCheck = newInquiryData.StatusCode
      }

      if (action == INQUIRY_ACTION_STRINGS.Close && !newInquiryData) {
        statusIdToCheck = data.StatusCode
        action = ''
      }

      // return the current role based on the relevant process flows and inquiry status
      const role =
        processFlowsRelativeToInquiries[0]?.Role.replace('[SECTION_NAME]', currentSection) ||
        previousSectionRole
      return { processFlowsRelativeToInquiries, role }
    }
  }

  function dueoutShowHide(button: any, showhide: ActionButton) {
    const btnName = button[0]

    switch (btnName) {
      case DUEOUT_ACTION_STRING.AssignTo:
        showhide.AssignTo = true
        break
      case DUEOUT_ACTION_STRING.Cancel:
        showhide.CancelDueout = true
        break
      case DUEOUT_ACTION_STRING.Close:
        showhide.CloseDueout = true
        break
      case DUEOUT_ACTION_STRING.Complete:
        showhide.Complete = true
        break
      case DUEOUT_ACTION_STRING.Respond:
        showhide.Respond = true
        break
    }
  }
  function isAssignedToInquiry(obj) {
    return !obj.AssignedTo || obj.AssignedTo.userID == me.userId
  }
  function inquiryShowHide(button: any, inquiry: Inquiry, showHideButton: ActionButton) {
    const btnName = button[0]
    let show = button[1]
    const statusThatCanCancel = [...MPF_ACTIVE_INQUIRY_KPI, 'SUBMITTED', 'REOPENED']
    const { CustomerActionRequired, PendingActionOutside, ResponseRequired } = inquiry
    // const hasRoleNotCustomer = role && role !== USER_ROLES.Customer
    const isFromSection = mpfSection.includes(inquiry['Section/MetadataValue'])
    const isNotCARorPAO = !CustomerActionRequired && !PendingActionOutside
    const isCustomer = me.userId === inquiry.Customer?.userID
    const isOwner = isCPOwner || isMPFOwner

    switch (btnName) {
      case INQUIRY_ACTION_STRINGS.AssignTo:
        if (show && (isFromSection || isOwner || isCSS || isLeadership)) {
          showHideButton.AssignTo = true
        }
        break
      /**
       * Cancel Button Visibility
       * ---
       * Customer can see Cancel button at Submitted/Reopened statuses
       * User that created the inquiry can not see the Cancel button
       * MPF Section Chief and MPF Leadership can see Cancel button at Submitted/Reopened statuses
       */
      case INQUIRY_ACTION_STRINGS.Cancel:
        if (
          isNotCARorPAO &&
          (show ||
            ((isSiteAdmin || isCPOwner || isCSS || isLeadership) &&
              statusThatCanCancel.includes(inquiry.StatusCode))) &&
          (me.userId !== inquiry.ItemCreatedBy.userID || isCustomer)
        ) {
          showHideButton.CancelInquiry = true
        }
        break
      case INQUIRY_ACTION_STRINGS.Close:
        if (isCustomer || (show && isOwner)) {
          showHideButton.Close = true
        }
        break
      case INQUIRY_ACTION_STRINGS.CustomerActionRequired:
        if (
          show &&
          (isFromSection || isOwner || isCSS || isLeadership) &&
          isNotCARorPAO &&
          isAssignedToInquiry(inquiry)
        ) {
          showHideButton.CustomerAction = true
        }
        break
      case INQUIRY_ACTION_STRINGS.CustomerActionComplete:
        if (show && CustomerActionRequired && (isAssignedToInquiry(inquiry) || isCustomer)) {
          showHideButton.CustomerActionComplete = true
        }
        break
      case INQUIRY_ACTION_STRINGS.Elevate:
        if (
          show &&
          (isFromSection || isOwner || isCSS || isLeadership) &&
          (pageType === 'inquiries' || pageType === 'inquirydetailview')
        ) {
          showHideButton.Elevate = true
        }
        break
      case INQUIRY_ACTION_STRINGS.PendingActionOutside:
        if (
          show &&
          (isFromSection || isOwner || isCSS || isLeadership) &&
          isNotCARorPAO &&
          isAssignedToInquiry(inquiry)
        ) {
          showHideButton.PendingActionOutside = true
        }
        break
      case INQUIRY_ACTION_STRINGS.OutsideActionComplete:
        if (
          show &&
          !CustomerActionRequired &&
          PendingActionOutside &&
          isAssignedToInquiry(inquiry)
        ) {
          showHideButton.OutsideActionComplete = true
        }
        break
      case INQUIRY_ACTION_STRINGS.Reopen:
        if (
          inquiry.StatusCode == INQUIRY_STATUS_IDS.Closed ||
          inquiry.StatusCode == INQUIRY_STATUS_IDS.Canceled
        ) {
          show = false
        } else if (show && isCustomer) {
          //|| me.userId === inquiry.ItemCreatedBy.userID
          showHideButton.Reopen = true
        } else if (show && (isOwner || isFromSection || isLeadership || isCSS)) {
          showHideButton.Reopen = true
        }
        break
      case INQUIRY_ACTION_STRINGS.Resolve:
        if (show && (isFromSection || isOwner || isCSS) && isNotCARorPAO) {
          showHideButton.Resolve = true
        }
        break
      case INQUIRY_ACTION_STRINGS.Respond:
        if (show) {
          const historyData = HistoryData
          const allEntries = [...historyData].filter(
            ({ ActionCode }) =>
              ActionCode === ACTIONS.Elevated ||
              ActionCode === ACTIONS.ChangedSection ||
              ActionCode === ACTIONS.OtherSection ||
              ActionCode === ACTIONS.Responded ||
              ActionCode === ACTIONS.Resolved
          )

          const needResponse: any[] = []
          let hasResponded = 0
          let showRespond = false
          const notAssigned = inquiry.AssignedTo === null
          const assignedAndAssignedToMe = inquiry.AssignedTo?.userID === me.userId
          const visibleToMe = notAssigned || assignedAndAssignedToMe

          allEntries.every((entry: any) => {
            // Resolving an Inquiry should break the response chain, so that Respond doesn't show.
            if (entry.ActionCode === ACTIONS.Resolved) return false // Exit the loop; prior respond data is irrelevant.
            if (entry.ActionCode === ACTIONS.Responded) {
              hasResponded += 1
            } else if (hasResponded > 0) {
              hasResponded -= 1
            } else {
              if (needResponse.length === 0) {
                if (
                  (entry.ActionCode === ACTIONS.ChangedSection ||
                    entry.ActionCode === ACTIONS.OtherSection) &&
                  !ResponseRequired
                ) {
                  showRespond = false
                } else if (
                  (entry.ActionCode === ACTIONS.Elevated ||
                    entry.ActionCode === ACTIONS.ChangedSection ||
                    entry.ActionCode === ACTIONS.OtherSection) &&
                  visibleToMe
                ) {
                  showRespond = true
                }
              }
              needResponse.push(entry)
            }
            return true
          })

          setRespondToUser(needResponse[0])
          showHideButton.Respond = showRespond
        }

        break
      case INQUIRY_ACTION_STRINGS.CancelResponseRequired:
        if (show && !data?.AssignedTo) {
          showHideButton.CancelResponseRequired = true
        }
    }
    // Validates if the user is either assigned to the inquiry or the inquiry is currently unassigned
  }
  function generateMultipleRoles(dataArray) {
    if (!dataArray) return { groupedRoles: {}, uniqueRoles: [] }

    const groupedRoles = dataArray.reduce((acc, item) => {
      const { processFlowsRelativeToInquiries, role } = generateCurrentRole(item)
      if (!role) {
        console.error('Encountered undefined or null role:', role)
        return acc
      }

      if (!acc[role]) {
        acc[role] = [] // Initialize an array for this role if it doesn't exist
      }

      if (
        Array.isArray(processFlowsRelativeToInquiries) &&
        processFlowsRelativeToInquiries.length > 0
      ) {
        acc[role].push({ processFlowsRelativeToInquiries, role }) // Keep the pair together
      } else {
        console.error(
          'Encountered undefined or null process flow:',
          processFlowsRelativeToInquiries
        )
      }

      return acc
    }, {})

    const uniqueRoles = Object.keys(groupedRoles)

    return { groupedRoles, uniqueRoles }
  }
  async function showHideWorkFlowButtons() {
    if (pageType === 'inquiries') {
      //Multiple Items

      const { groupedRoles, uniqueRoles } = generateMultipleRoles(selectedItems)

      if (uniqueRoles.length === 1) {
        const flowsToUse = groupedRoles[uniqueRoles[0]][0].processFlowsRelativeToInquiries || []
        setCurrentUserRole(uniqueRoles[0])
        if (flowsToUse?.length > 0)
          setStatusRelativeToUser(
            getStatusRespectToUser(flowsToUse, selectedItems[0]['SectionValue'])
          )
        if (!selectedItems[0].ResponseRequired) {
          if (uniqueRoles[0]) {
            // show or hide buttons based on the process flow metadata for that user
            const flows = Object?.entries(flowsToUse[0])
            flows?.forEach((item) => {
              if (item[0] === 'AssignToOptions' || item[0] === 'ElevateToOptions') {
                createOptionHelper(item, selectedItems[0])
              }
            })
          }
        }
      }
    } else {
      //Single Item
      const { processFlowsRelativeToInquiries, role } = generateCurrentRole(data)
      const flowsToUse = processFlowsRelativeToInquiries || []
      const flows = flowsToUse.length > 0 ? Object?.entries(flowsToUse[0]) : []
      setCurrentUserRole(role)
      if (flowsToUse?.length) {
        setStatusRelativeToUser(getStatusRespectToUser(flowsToUse, data))
      }
      if (!data.ResponseRequired) {
        if (role) {
          // show or hide buttons based on the process flow metadata for that user
          const showhide = { ...initialBtnShowHide }
          flows?.forEach((item) => {
            if (typeof item[1] == 'boolean' && item[1] === true) {
              // Need to have different inquiryShowHide for due out.
              flows.length === 10
                ? dueoutShowHide(item, showhide)
                : inquiryShowHide(item, data, showhide)
            } else if (item[0] === 'AssignToOptions' || item[0] === 'ElevateToOptions') {
              createOptionHelper(item, data)
            }
          })
          setBtnShowHide(showhide)
        } else {
          setBtnShowHide(initialBtnShowHide)
        }
      } else {
        // inquiry has been assigned to other section with response required
        const showhide = { ...initialBtnShowHide }
        // if (!role && data.ResponseRequired) {
        //   inquiryShowHide([INQUIRY_ACTION_STRINGS.CancelResponseRequired, true], data, showhide)
        // }
        if (role && role !== USER_ROLES.Customer) {
          // PLEASE IGNORE inquiryShowHide ERROR IN THIS BLOCK.
          // users in current section can respond to elevation
          if (mpfSection.includes(data['Section/MetadataValue']) || isCPOwner || isMPFOwner) {
            if (isCPOwner || isMPFOwner) {
              inquiryShowHide([INQUIRY_ACTION_STRINGS.CancelResponseRequired, true], data, showhide)
            }
            inquiryShowHide([INQUIRY_ACTION_STRINGS.AssignTo, flows[0][1]], data, showhide)
            inquiryShowHide([INQUIRY_ACTION_STRINGS.Respond, true], data, showhide)
            setBtnShowHide(showhide)
            flows?.forEach((item) => {
              if (item[0] === 'AssignToOptions') {
                createOptionHelper(item, data)
              }
            })
          }
          //
          if (role && role.includes(USER_ROLES.Leadership)) {
            inquiryShowHide([INQUIRY_ACTION_STRINGS.CancelResponseRequired, true], data, showhide)
            setBtnShowHide(showhide)
          }
          // users in previous section can cancel response required
          if (mpfSection.includes(data['PreviousSection/MetadataValue'])) {
            setCurrentUserRole(
              role.replace(data['Section/MetadataValue'], data['PreviousSection/MetadataValue'])
            )
            inquiryShowHide([INQUIRY_ACTION_STRINGS.CancelResponseRequired, true], data, showhide)
            setBtnShowHide(showhide)
          }
        }
        setBtnShowHide(showhide)
      }
    }
  }

  const createOptionHelper = (item, selectedItem) => {
    let relativeServicingBy = item[1]?.split(';')
    const curServicingBy = selectedItem.InquiryID
      ? selectedItem.CurrentlyServicingBy
      : selectedItem.ServicingBy
    if (relativeServicingBy !== undefined) {
      // Runs for CSS assign to options
      if (curServicingBy === 'CSS') {
        relativeServicingBy = [relativeServicingBy[0]]
        // Runs for MPF/CP Owner when response is required assign to options
      } else if (relativeServicingBy.includes('MPF Leadership') && selectedItem.ResponseRequired) {
        relativeServicingBy.shift()
        relativeServicingBy.pop()
        // Runs for MPF/CP Owner without response is required assign to options
      } else if (
        (relativeServicingBy.includes('CSS') && item[0] === 'AssignToOptions') ||
        (relativeServicingBy.includes('[SECTION_NAME] Technician') &&
          item[0] === 'ElevateToOptions')
      ) {
        relativeServicingBy.shift()
      }
      const result = relativeServicingBy?.map((t) => {
        const dataSection = selectedItem['Section/MetadataValue'] || selectedItem['SectionValue']
        const label = t.replace('[SECTION_NAME]', dataSection)
        const valueFilter = label === 'CSS' ? dataSection + ' CSS' : label
        const value = inquiryStatuses
          .filter((status) => status.StatusDescription.replace('-', ' ') === valueFilter)
          .map((statusCode) => statusCode.StatusCode)
        return {
          label: label,
          value: value[0],
        }
      })
      if (item[0] === 'AssignToOptions') setAssignToOptions(result)
      if (item[0] === 'ElevateToOptions') setElevateToOptions(result)

      return !item.AssignedTo || item.AssignedTo == me.userId
    }
  }
  const getStatusRespectToUser = (pr, item): string => {
    const sec = item?.['Section/MetadataValue']
    const { StatusCode } = item
    const { UserType } = pr[0]
    let trimUserType = UserType?.trim().split(' ').join('_')
    const trimSec = sec?.split(' ').join('_')
    if (trimUserType === 'Leadership') {
      trimUserType = `MPF_${trimUserType}`
    } else if (trimUserType === 'SiteAdmin') {
      if (StatusCode === 'MPF_LEADERSHIP') {
        trimUserType = 'MPF_LEADERSHIP'
      } else if (
        ((StatusCode === INQUIRY_STATUS_IDS.Submitted 
          || StatusCode === INQUIRY_STATUS_IDS.Reopened) &&
          item.ServicingBy === 'MPF') ||
        (item.DueOutID && item.ServicingBy === 'MPF')
      ) {
        trimUserType = 'TECHNICIAN'
      } else if (
        ((StatusCode === INQUIRY_STATUS_IDS.Submitted 
          || StatusCode === INQUIRY_STATUS_IDS.Reopened) &&
          item.ServicingBy === 'CSS') ||
        (item.DueOutID && item.ServicingBy === 'CSS')
      ) {
        trimUserType = 'CSS'
      } else return StatusCode
    }
    const returnedVal = `${trimSec}-${trimUserType}`
    return returnedVal.toUpperCase()
  }

  useEffect(() => {
    // This triggers to reset the action button popup whenever the user unintentionally hides the popups.
    const resetPopUpWindow = () => {
      const updatedButtons = { ...actionBtnShowHide }
      for (const button in updatedButtons) {
        if (button) {
          updatedButtons[button] = false
        }
      }
      setActionBtnShowHide(updatedButtons)
    }
    resetPopUpWindow()
  }, [selection.allLoadedRecordKeys, refresh])

  useEffect(() => {
    if (!fetchSelectedItems) return
    const fetchData = async () => {
      try {
        const data = await fetchSelectedItems() // No need for the additional check here
        setSelectedItems(data)
      } catch (error) {
        console.error('Error fetching data:', error)
      }
    }
    fetchData()
  }, [selection.selectedRecordKeys]) // Assuming you want to re-fetch when selectedRecordKeys changes

  useEffect(() => {
    if (data && userProcessFlows?.length > 0) showHideWorkFlowButtons()
  }, [data, userProcessFlows, HistoryData])

  useEffect(() => {
    if (selectedItems && pageType === 'inquiries') showHideWorkFlowButtons()
  }, [selectedItems, pageType, HistoryData])

  useEffect(() => {
    setPopupHeight(window.innerHeight - (offsetTopValue + 130))
    const popupWidthData = popupBtnRef.current ? popupBtnRef.current.offsetWidth : 0
    if (popupWidthData < xPositionValue) {
      setXPositionValueUpdate(xPositionValue - popupWidthData)
    } else if (
      popupWidthData > offsetLeftValue &&
      popupWidthData < window.innerWidth - (offsetLeftValue + offsetWidthValue)
    ) {
      setXPositionValueUpdate(offsetLeftValue)
    } else if (
      popupWidthData > offsetLeftValue &&
      popupWidthData > window.innerWidth - (offsetLeftValue + offsetWidthValue)
    ) {
      setXPositionValueUpdate(0)
    }
  }, [actionBtnShowHide, btnShowHide])

  useEffect(() => {
    const element: any = document.getElementsByClassName('menus')
    if (btnShowHide?.[openedButton]) {
      if (element && element[0]?.classList?.contains('menuexpand')) {
        Promise.all([
          setActionBtnShowHide({
            AssignTo: false,
            CancelDueout: false,
            CancelInquiry: false,
            CancelResponseRequired: false,
            Close: false,
            CloseDueout: false,
            Complete: false,
            CustomerAction: false,
            CustomerActionComplete: false,
            Elevate: false,
            OutsideActionComplete: false,
            PendingActionOutside: false,
            Reopen: false,
            Resolve: false,
            Respond: false,
          }),
        ]).then(() => {
          setTimeout(() => {
            showPopup()
          }, 200)
        })
      }
      if (element && element[0]?.classList?.contains('menucollapsed')) {
        Promise.all([
          setActionBtnShowHide({
            AssignTo: false,
            CancelDueout: false,
            CancelInquiry: false,
            CancelResponseRequired: false,
            Close: false,
            CloseDueout: false,
            Complete: false,
            CustomerAction: false,
            CustomerActionComplete: false,
            Elevate: false,
            OutsideActionComplete: false,
            PendingActionOutside: false,
            Reopen: false,
            Resolve: false,
            Respond: false,
          }),
        ]).then(() => {
          setTimeout(() => {
            showPopup()
          }, 200)
        })
      }
    }
  }, [isMenusExpanded])

  const showPopup = () => {
    const ele: any = document.getElementById(openedButton)
    const elementHeight = ele.offsetHeight
    const offSetTopValue = ele.offsetTop
    const popupTop = elementHeight + offSetTopValue
    const offsetWidthValue = ele.offsetWidth
    const offsetLeftValue = ele.offsetLeft
    const popupLeft = offsetWidthValue + offsetLeftValue
    popupCloseOpenFunctionality(
      openedButton,
      true,
      popupTop,
      popupLeft,
      offsetLeftValue,
      elementHeight,
      offsetWidthValue
    )
  }

  useEffect(() => {
    if (refresh) {
      // Call refetch when refresh is changed
      showHideWorkFlowButtons()
    }
  }, [refresh])

  return (
    <>
      {displayAlert && (
        <Alert
          alerttextclass='poppins-semibold font-13 text-center'
          btn1className='btn btn btn-sm font-12 poppins-semibold btn-primary whitetext border-radius text-uppercase'
          btn1iconclassNmae='icon-checked font-12 pe-1'
          btn2classNmae='btn btn btn-border1 darktext btn-sm poppins-semibold font-12 border-radius text-uppercase'
          btn2iconclassNmae='icon-close color-primary font-12 pe-1'
          cancel='Cancel'
          className='alert-info'
          message={alertMessage}
          onClick={() => {
            setAlertMessage('')
            setDisplayAlert(false)
          }}
          yes='OK'
        />
      )}
      {btnShowHide.CustomerAction && pageType !== 'inquiries' && (
        <BasicActionButton
          action={ACTION_BUTTON_POPUP_CONTROL.CustomerAction}
          actionType={actionType}
          buttonColor='bgcolor-27'
          currentUserRole={currentUserRole}
          data={data}
          icon='icon-profilecheck me-1'
          id={'CustomerAction'}
          name='Customer Action Required'
          popupBtnRef={popupBtnRef}
          popupClassName='customeractionpopup'
          popupCloseOpenFunctionality={popupCloseOpenFunctionality}
          setRefresh={setRefresh}
          showHide={actionBtnShowHide.CustomerAction}
          statusRelativeToUser={statusRelativeToUser}
          style={{
            left: xPositionValueUpdate,
            maxHeight: popupHeight,
            overflow: 'auto',
            position: 'absolute',
            right: '0px',
            top: popupTop + 0,
          }}
        />
      )}
      {btnShowHide.CustomerActionComplete && pageType !== 'inquiries' && (
        <BasicActionButton
          action={ACTION_BUTTON_POPUP_CONTROL.CustomerActionComplete}
          actionType={actionType}
          buttonColor='bgcolor-26'
          currentUserRole={currentUserRole}
          data={data}
          icon='icon-pending me-1'
          id={'CustomerActionComplete'}
          name='Customer Action Complete'
          popupBtnRef={popupBtnRef}
          popupClassName='completepopup'
          popupCloseOpenFunctionality={popupCloseOpenFunctionality}
          setRefresh={setRefresh}
          showHide={actionBtnShowHide.CustomerActionComplete}
          statusRelativeToUser={statusRelativeToUser}
          style={{
            left: xPositionValueUpdate,
            maxHeight: popupHeight,
            overflow: 'auto',
            position: 'absolute',
            right: '0px',
            top: popupTop + 0,
          }}
        />
      )}
      {btnShowHide.PendingActionOutside && pageType !== 'inquiries' && (
        <BasicActionButton
          action={ACTION_BUTTON_POPUP_CONTROL.PendingActionOutside}
          actionType={actionType}
          buttonColor='bgcolor-26'
          currentUserRole={currentUserRole}
          data={data}
          icon='icon-pending me-1'
          id='PendingActionOutside'
          name='Pending Action Outside Portal'
          popupBtnRef={popupBtnRef}
          popupClassName='pendingactionpopup'
          popupCloseOpenFunctionality={popupCloseOpenFunctionality}
          setRefresh={setRefresh}
          showHide={actionBtnShowHide.PendingActionOutside}
          statusRelativeToUser={statusRelativeToUser}
          style={{
            left: xPositionValueUpdate,
            maxHeight: popupHeight,
            overflow: 'auto',
            position: 'absolute',
            right: '0px',
            top: popupTop + 0,
          }}
        />
      )}
      {btnShowHide.OutsideActionComplete && pageType !== 'inquiries' && (
        <BasicActionButton
          action={ACTION_BUTTON_POPUP_CONTROL.OutsideActionComplete}
          actionType={actionType}
          buttonColor='bgcolor-26'
          currentUserRole={currentUserRole}
          data={data}
          icon='icon-pending me-1'
          id='OutsideActionComplete'
          name='Action Outside Portal Complete'
          popupBtnRef={popupBtnRef}
          popupClassName='completepopup'
          popupCloseOpenFunctionality={popupCloseOpenFunctionality}
          setRefresh={setRefresh}
          showHide={actionBtnShowHide.OutsideActionComplete}
          statusRelativeToUser={statusRelativeToUser}
          style={{
            left: xPositionValueUpdate,
            maxHeight: popupHeight,
            overflow: 'auto',
            position: 'absolute',
            right: '0px',
            top: popupTop + 0,
          }}
        />
      )}
      {(btnShowHide.AssignTo || (pageType === 'inquiries' && showAssignTo)) && (
        <AssignToButton
          action='AssignTo'
          actionBtnShowHide={actionBtnShowHide}
          assignToOptions={assignToOptions}
          buttonColor='bgcolor-28 me-1'
          currentUserRole={currentUserRole}
          icon='icon-profilecheck me-1'
          id={'AssignTo'}
          isDueOut={actionType === 'Dueout'}
          multipleItems={selectedItems}
          name='Assign To'
          popupBtnRef={popupBtnRef}
          popupClassName='assigntonpopup'
          popupCloseOpenFunctionality={popupCloseOpenFunctionality}
          setActionBtnShowHide={setActionBtnShowHide}
          setDisableCheckBox={setDisableCheckBox}
          setRefresh={setRefresh}
          showHide={actionBtnShowHide.AssignTo}
          singleItem={data}
          statusRelativeToUser={statusRelativeToUser}
          style={{
            left: xPositionValueUpdate,
            maxHeight: popupHeight,
            overflow: 'auto',
            position: 'absolute',
            right: '0px',
            top: popupTop + 0,
          }}
        />
      )}
      {(btnShowHide.Elevate || (pageType === 'inquiries' && showElevate)) && (
        <ElevateButton
          action={ACTION_BUTTON_POPUP_CONTROL.Elevate}
          buttonColor='bgcolor-29 me-1'
          currentUserRole={currentUserRole}
          elevateInputs={elevateInputs}
          elevateTo={elevateToOptions}
          icon='icon-Elevate me-1'
          id='Elevate'
          multipleItems={selectedItems}
          name='Elevate'
          popupBtnRef={popupBtnRef}
          popupClassName='elevatepopup'
          popupCloseOpenFunctionality={popupCloseOpenFunctionality}
          setDisableCheckBox={setDisableCheckBox}
          setElevateInputs={setElevateInputs}
          setRefresh={setRefresh}
          setShowElevateErrorMsgs={setShowElevateErrorMsgs}
          showElevateErrorMsgs={showElevateErrorMsgs}
          showHide={actionBtnShowHide.Elevate}
          singleItem={data}
          style={{
            left: xPositionValueUpdate,
            maxHeight: popupHeight,
            overflow: 'auto',
            position: 'absolute',
            right: '0px',
            top: popupTop + 0,
          }}
        />
      )}
      {btnShowHide.Resolve && pageType !== 'inquiries' && (
        <BasicActionButton
          action={ACTION_BUTTON_POPUP_CONTROL.Resolve}
          actionType={actionType}
          buttonColor='bgcolor-57'
          currentUserRole={currentUserRole}
          data={data}
          icon='icon-checked me-1'
          id={'Resolve'}
          name='Resolve'
          // okClick = {Resolve()}
          popupBtnRef={popupBtnRef}
          popupClassName='Resolvepopup'
          popupCloseOpenFunctionality={popupCloseOpenFunctionality}
          setRefresh={setRefresh}
          showHide={actionBtnShowHide.Resolve}
          statusRelativeToUser={statusRelativeToUser}
          style={{
            left: xPositionValueUpdate,
            maxHeight: popupHeight,
            overflow: 'auto',
            position: 'absolute',
            right: '0px',
            top: popupTop + 0,
          }}
        />
      )}
      {btnShowHide.CancelResponseRequired && pageType !== 'inquiries' && (
        <BasicActionButton
          action={ACTION_BUTTON_POPUP_CONTROL.CancelResponseRequired}
          actionType={actionType}
          buttonColor='bgcolor-58'
          currentUserRole={currentUserRole}
          data={data}
          icon='icon-close me-1 font-10'
          id={'CancelResponseRequired'}
          name='Cancel Response Required'
          popupBtnRef={popupBtnRef}
          popupClassName='cancelresponserequiredpopup'
          popupCloseOpenFunctionality={popupCloseOpenFunctionality}
          setRefresh={setRefresh}
          showHide={actionBtnShowHide.CancelResponseRequired}
          statusRelativeToUser={statusRelativeToUser}
          style={{
            left: xPositionValueUpdate,
            maxHeight: popupHeight,
            overflow: 'auto',
            position: 'absolute',
            right: '0px',
            top: popupTop + 0,
          }}
        />
      )}
      {btnShowHide.Respond && pageType !== 'inquiries' && !data?.DueOutID && (
        <BasicActionButton
          action={ACTION_BUTTON_POPUP_CONTROL.Respond}
          actionType={actionType}
          buttonColor='bgcolor-46'
          currentUserRole={currentUserRole}
          data={{ ...data, respondToUser: respondToUser }}
          icon='icon-close me-1 font-10'
          id={'Respond'}
          name='Respond'
          popupBtnRef={popupBtnRef}
          popupClassName='respondpopup'
          popupCloseOpenFunctionality={popupCloseOpenFunctionality}
          setRefresh={setRefresh}
          showHide={actionBtnShowHide.Respond}
          statusRelativeToUser={statusRelativeToUser}
          style={{
            left: xPositionValueUpdate,
            maxHeight: popupHeight,
            overflow: 'auto',
            position: 'absolute',
            right: '0px',
            top: popupTop + 0,
          }}
        />
      )}
      {btnShowHide.Respond && data?.DueOutID && (
        <DueoutBasicActionButton
          action={ACTION_BUTTON_POPUP_CONTROL.Respond}
          actionType={actionType}
          buttonColor='bgcolor-46'
          currentUserRole={currentUserRole}
          data={{ ...data, respondToUser: respondToUser }}
          icon='icon-close me-1 font-10'
          id={'Respond'}
          name='Respond'
          popupBtnRef={popupBtnRef}
          popupClassName='respondpopup'
          popupCloseOpenFunctionality={popupCloseOpenFunctionality}
          setRefresh={setRefresh}
          showHide={actionBtnShowHide.Respond}
          statusRelativeToUser={statusRelativeToUser}
          style={{
            left: xPositionValueUpdate,
            maxHeight: popupHeight,
            overflow: 'auto',
            position: 'absolute',
            right: '0px',
            top: popupTop + 0,
          }}
        />
      )}
      {btnShowHide.Reopen && pageType !== 'inquiries' && (
        <BasicActionButton
          action={ACTION_BUTTON_POPUP_CONTROL.Reopen}
          actionType={actionType}
          buttonColor='bgcolor-61'
          currentUserRole={currentUserRole}
          data={data}
          icon='icon-formcancel me-1'
          id='Reopen'
          name='Reopen'
          popupBtnRef={popupBtnRef}
          popupClassName='reopenpopup'
          popupCloseOpenFunctionality={popupCloseOpenFunctionality}
          setRefresh={setRefresh}
          showHide={actionBtnShowHide.Reopen}
          statusRelativeToUser={statusRelativeToUser}
          style={{
            left: xPositionValueUpdate,
            maxHeight: popupHeight,
            overflow: 'auto',
            position: 'absolute',
            right: '0px',
            top: popupTop + 0,
          }}
        />
      )}
      {btnShowHide.Close && pageType !== 'inquiries' && (
        <BasicActionButton
          action={ACTION_BUTTON_POPUP_CONTROL.Close}
          actionType={actionType}
          buttonColor='bgcolor-59'
          currentUserRole={currentUserRole}
          data={data}
          icon='icon-formcancel me-1'
          id={'Close'}
          name='Close'
          popupBtnRef={popupBtnRef}
          popupClassName='closepopup'
          popupCloseOpenFunctionality={popupCloseOpenFunctionality}
          setRefresh={setRefresh}
          showHide={actionBtnShowHide.Close}
          statusRelativeToUser={statusRelativeToUser}
          style={{
            left: xPositionValueUpdate,
            maxHeight: popupHeight,
            overflow: 'auto',
            position: 'absolute',
            right: '0px',
            top: popupTop + 0,
          }}
        />
      )}
      {btnShowHide.Complete && pageType !== 'inquiries' && (
        <DueoutBasicActionButton
          action={ACTION_BUTTON_POPUP_CONTROL.Complete}
          actionType={actionType}
          buttonColor='bgcolor-29'
          currentUserRole={currentUserRole}
          data={data}
          icon='icon-checked me-1'
          id={'Complete'}
          name='Complete'
          popupBtnRef={popupBtnRef}
          popupClassName='completepopup'
          popupCloseOpenFunctionality={popupCloseOpenFunctionality}
          setRefresh={setRefresh}
          showHide={actionBtnShowHide.Complete}
          statusRelativeToUser={statusRelativeToUser}
          style={{
            left: xPositionValueUpdate,
            maxHeight: popupHeight,
            overflow: 'auto',
            position: 'absolute',
            right: '0px',
            top: popupTop + 0,
          }}
        />
      )}
      {btnShowHide.CloseDueout && pageType !== 'inquiries' && (
        <DueoutBasicActionButton
          action={ACTION_BUTTON_POPUP_CONTROL.CloseDueout}
          actionType={actionType}
          buttonColor='bgcolor-59'
          currentUserRole={currentUserRole}
          data={data}
          icon='icon-formcancel me-1'
          id={'CloseDueout'}
          name='Close Due out'
          popupBtnRef={popupBtnRef}
          popupClassName='closedueoutpopup'
          popupCloseOpenFunctionality={popupCloseOpenFunctionality}
          setRefresh={setRefresh}
          showHide={actionBtnShowHide.CloseDueout}
          statusRelativeToUser={statusRelativeToUser}
          style={{
            left: xPositionValueUpdate,
            maxHeight: popupHeight,
            overflow: 'auto',
            position: 'absolute',
            right: '0px',
            top: popupTop + 0,
          }}
        />
      )}
      {btnShowHide.CancelDueout && pageType !== 'inquiries' && (
        <DueoutBasicActionButton
          action={ACTION_BUTTON_POPUP_CONTROL.CancelDueout}
          actionType={actionType}
          buttonColor='bgcolor-61'
          currentUserRole={currentUserRole}
          data={data}
          icon='icon-formcancel me-1'
          id={'CancelDueout'}
          name='Cancel Due out'
          popupBtnRef={popupBtnRef}
          popupClassName='canceldueoutpopup'
          popupCloseOpenFunctionality={popupCloseOpenFunctionality}
          setRefresh={setRefresh}
          showHide={actionBtnShowHide.CancelDueout}
          statusRelativeToUser={statusRelativeToUser}
          style={{
            left: xPositionValueUpdate,
            maxHeight: popupHeight,
            overflow: 'auto',
            position: 'absolute',
            right: '0px',
            top: popupTop + 0,
          }}
        />
      )}
      {btnShowHide.CancelInquiry && pageType !== 'inquiries' && (
        <BasicActionButton
          action={ACTION_BUTTON_POPUP_CONTROL.CancelInquiry}
          actionType={actionType}
          buttonColor='bgcolor-24'
          currentUserRole={currentUserRole}
          data={data}
          icon='icon-formcancel me-1'
          id='CancelInquiry'
          name='Cancel Inquiry'
          popupBtnRef={popupBtnRef}
          popupClassName='cancelinquirypopup'
          popupCloseOpenFunctionality={popupCloseOpenFunctionality}
          setRefresh={setRefresh}
          showHide={actionBtnShowHide.CancelInquiry}
          statusRelativeToUser={statusRelativeToUser}
          style={{
            left: xPositionValueUpdate,
            maxHeight: popupHeight,
            overflow: 'auto',
            position: 'absolute',
            right: '0px',
            top: popupTop + 0,
          }}
        />
      )}
      {pageType !== 'inquiries' && (
        <Buttons
          aria-label='Back'
          className='btn-lg font-12 bgcolor-60 whitetext text-nowrap border-radius poppins-bold text-uppercase '
          icon='icon-left-arrow me-1'
          label='Back'
          onClick={(e: any) => redirectToBack()}
        />
      )}
    </>
  )
}
export default ActionButtonsContainer
